import { gql } from "@apollo/client";

// Job Requisition admin config (TP-1588 backend) — served by the listings
// subgraph via the federation gateway. Consumed by the Settings → Approval
// Config tab (TP-1598). Mutations return the whole ApprovalConfig so the cache
// updates from the response without a refetch.

export const GetApprovalConfig = gql`
  query GetApprovalConfig {
    approvalConfig {
      enabled
      approvalTypes
      approvers {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const SetRequisitionWorkflowEnabled = gql`
  mutation SetRequisitionWorkflowEnabled($enabled: Boolean!) {
    setRequisitionWorkflowEnabled(enabled: $enabled) {
      enabled
      approvalTypes
    }
  }
`;

export const AddRequisitionApprovalType = gql`
  mutation AddRequisitionApprovalType($label: String!) {
    addRequisitionApprovalType(label: $label) {
      enabled
      approvalTypes
    }
  }
`;

export const RemoveRequisitionApprovalType = gql`
  mutation RemoveRequisitionApprovalType($label: String!) {
    removeRequisitionApprovalType(label: $label) {
      enabled
      approvalTypes
    }
  }
`;

export const AddRequisitionApprover = gql`
  mutation AddRequisitionApprover($userId: ID!) {
    addRequisitionApprover(userId: $userId) {
      approvers {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const RemoveRequisitionApprover = gql`
  mutation RemoveRequisitionApprover($userId: ID!) {
    removeRequisitionApprover(userId: $userId) {
      approvers {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
